import {listPageCacheConstants} from '../constants';

const listPageCacheReducer = (state = {}, action) => {
  const {type} = action;
  switch (type) {
    case listPageCacheConstants.SAVE_LIST_PAGE_CACHE:
      return {
        ...state,
        [action.payload.key]: {
          url: action.payload.url,
          tableQuery: action.payload.tableQuery,
          tableData: action.payload.tableData,
        }
      };
    case listPageCacheConstants.CLEAR_LIST_PAGE_CACHE:
      return {
        ...state,
        [action.payload.key]: undefined,
      };
    case listPageCacheConstants.CLEAR_ALL_LIST_PAGE_CACHE:
      return {};
    case listPageCacheConstants.RELOAD_LIST_PAGE_CACHE_CURRENT_PAGE: {
      const {key} = action.payload;
      if (!state[key]) return state;
      return {
        ...state,
        [key]: {
          ...state[key],
          reloadCurrentPage: true,
        },
      };
    }
    case listPageCacheConstants.UPDATE_LIST_PAGE_CACHE_ITEM: {
      const {key, idKey, item} = action.payload;
      const entry = state[key];
      if (!entry?.tableData?.rows || item?.[idKey] === undefined) return state;
      return {
        ...state,
        [key]: {
          ...entry,
          tableData: {
            ...entry.tableData,
            rows: entry.tableData.rows.map((row) =>
              row[idKey] === item[idKey] ? {...row, ...item} : row
            ),
          },
        },
      };
    }
    default:
      return state;
  }
};

export default listPageCacheReducer;
